export default function HeaderLeft(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none" {...props}>
            <g filter="url(#filter0_d_2420_2041)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.4228 2.42506C18.5886 4.20046 16.6204 7.29631 14.7965 7.04986C16.0866 3.8621 15.7372 0.735572 13.9498 0.422531C11.5517 0.00253487 9.77958 4.0915 12.3545 6.92856C12.6409 7.24408 12.9436 7.48315 13.2564 7.65338C12.4891 9.03543 11.4553 10.2254 10.266 10.7384C7.04953 12.126 4.98235 11.5663 3.98683 11.2968C3.91695 11.2779 3.85235 11.2604 3.793 11.2452C2.8882 11.0121 1.57184 13.2422 3.38144 13.7083C5.19104 14.1744 9.62662 14.131 12.892 10.229C13.4868 9.51833 13.9795 8.75514 14.3732 7.97962C16.6103 8.12304 18.9705 5.4627 19.4228 2.42506ZM13.7211 6.6157C11.6068 4.77057 12.1491 0.0774299 13.9172 1.0984C14.9635 1.70259 14.7366 4.24752 13.7211 6.6157Z"
                    fill="url(#paint0_linear_2420_2041)"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_2420_2041"
                    x="0.476562"
                    y="0.392578"
                    width="20.9453"
                    height="17.5176"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2420_2041" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2420_2041" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_2420_2041" x1="-2.85909" y1="8.45612" x2="22.6372" y2="1.70613" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFF730" />
                    <stop offset="0.195312" stopColor="#FFC700" />
                    <stop offset="0.60249" stopColor="#FFE872" />
                    <stop offset="0.867876" stopColor="#FF8A00" />
                    <stop offset="1" stopColor="#FED05A" />
                </linearGradient>
            </defs>
        </svg>
    );
}
